let func = {
	byteSize : function(n) {
		var i = 0;
		var sib_prefix = ['B','ki','Mi', 'Gi', 'Ti', 'Pi', 'Ei', 'Zi', 'Yi'];
		
		while( n >= 1000 ) {
			i++;
			n /= 1024;
		}
		return (i === 0 ? n.toString() : n.toFixed( 3 - parseInt(n,10).toString().length )) + ( sib_prefix[ i ] || "..E" );
	},
	JSON_PRETTY : {
		"parse": function (member) {
			return this[(member == undefined) ? 'null' : member.constructor.name.toLowerCase()](member);
		},
		"null": function (value) {
			return this['value']('null', 'null');
		},
		"array": function (value) {
			let results = '';
			for (let x=0; x < value.length; x++) {
				results += '<li>' + this['parse'](value[x]) + '</li>';
			}
			return '[ <span class="icon-collapse"></span> ' + ((results.length > 0) ? '<ul class="array">' + results + '</ul>' : '') + ' ]';
		},
		"object": function (value) {
			let results = '';
			for (let member in value) {
				results += '<li>' + this['value']('object', member) + ': ' + this['parse'](value[member]) + '</li>';
			}
			return '{ <span class="icon-collapse"></span> ' + ((results.length > 0) ? '<ul class="object">' + results + '</ul>' : '') + ' }';
		},
		"number": function (value) {
			return this['value']('number', value);
		},
		"string": function (value) {
			return this['value']('string', value);
		},
		"boolean": function (value) {
			return this['value']('boolean', value);
		},	
		"value": function (type, value) {
			if (/^(http|https):\/\/[^\s]+$/.test(value)) {
				return this['value'](type, '<a href="' + value + '" target="_blank">' + value + '</a>');
			}
			return '<span class="' + type + '">' + value + '</span>';
		}
	},
	openJson : (title, obj)=>{
		let $modal = $(`<div class="ui-modal modal ui-json-viewer"></div>`),
				$json = $(`<div class="json-parser"></div>`),
				$close = $(`<span class="modal-close">&times;</span>`);
		$close.click(e=>{$(e.target).parents('.modal').remove();});
		$modal.append($(`<div class="viewer-bg"></div>`)).append($(`<div class="viewer-header">${title}</div>`).append($close));
		$json.html(func.JSON_PRETTY.parse(obj));

		$json.find('.icon-collapse').click(e=>{
			$(e.target).toggleClass('expand');
		});
		$modal.css('top', `${$(document).scrollTop()+200}px`).css('left', `${$(document).scrollLeft()+300}px`);
		$('body').append($modal.append($json));
		func.drag($modal);
	},
	filterInput: values=>{
		let getDropDownOptions = options => {
			return options.map(option => {
				let menu = {};
				menu.title = option;
				menu.action = () => {
					// 선택한 값으로 등록
					//console.log('선택값:', option);
					$input.val(option);
					$input.trigger('keyup');
					selectItemIdx = -1;
				};
				return menu;
			});
		};
		let resetSelectedItem = () => {
			selectItemIdx = -1;
			$list.children('li').removeClass('selected');
		}
		let $compWrap = $(`<dl class="ui-filter-component"><dt class="filter-title">Filter Index</dt><dd><input class="filter-input" /></dd><dd class="filter-menu"></dd></dl>`);
		let $ddmenu = $compWrap.find('.filter-menu').append(func.dropdown(getDropDownOptions(values)));
		let $list = $ddmenu.find('.ui-dropdown-menu > ul');
		let selectItemIdx = -1;
		let $input = $compWrap.find('.filter-input').keyup(e => {
			let $nodes = $('.ui-cluster-index th,td');
			let text = $(e.target).val();
			let keyCode = e.keyCode;
			if (text) {
				$nodes.each((i,node) => {
					let $node = $(node);
					let dataName = $node.data('name');
					if(dataName) {
						if(dataName.indexOf(text) === 0) {
							$node.show();
						}else{
							$node.hide();
						}
					}
				});
				$list.children('li').each((i, el) => {
					if(el.textContent.indexOf(text) === 0) {
						$(el).show();
					}else{
						$(el).hide();
					}
				});
			} else {
				$list.children('li').show();
				$nodes.show();
			}
			$list.show();
			if (keyCode !== 37 && keyCode !== 38 && keyCode !== 39 && keyCode !== 40) {
				resetSelectedItem();
			}
		});
		$input.keydown(e => {
			let keyCode = e.keyCode;
			// 위아래 화살표인 경우 리스트 선택으로 변경
			if ($list.is(':visible') && (keyCode === 40 || keyCode === 38)) {
				let visibleSize = $list.children('li:visible').length;
				switch (keyCode) {
					case 40:
						selectItemIdx = selectItemIdx + 1;
						if (selectItemIdx >= visibleSize) {
							selectItemIdx = 0;
						}
						break;
					case 38:
						selectItemIdx = selectItemIdx - 1;
						if (selectItemIdx < 0) {
							selectItemIdx = visibleSize - 1;
						}
						break;
				}
				$list.children('li').removeClass('selected');
				$list.children('li:visible').eq(selectItemIdx).addClass('selected');
				let selectedItemTop = $list.children('li:visible').eq(selectItemIdx).position().top;
				$list.scrollTop(Math.floor((selectedItemTop + $list.scrollTop() + $list.children('li').eq(0).height()) / $list.height()) * $list.height());
				e.preventDefault();
				return false;
			} else if ($list.is(':visible') && keyCode === 13) {
				$list.children('li.selected').click();
			}
		});
		$input.focusout(()=>{
			$list.hide();
			resetSelectedItem();
		});
		return $compWrap;
	},
	dropdown : menu=>{
		let $menuWrap = $(`<div class="ui-dropdown-menu"></div>`),
				$ddMenu = $(`<ul></ul>`),
				isHover = false;
		menu.forEach(x=>{
			if(x.action){
				let $menu = $(`<li>${x.title}</li>`).click(()=>{
					x.action();
					$ddMenu.hide();
				});
				if(x.toggle){
					$menu.addClass('tgl-state-menu');
				}
				$ddMenu.append($menu);
			}else{
				$ddMenu.append($(`<li class="division">${x.title}</li>`));
			}
		});
		$ddMenu.mouseenter(()=>{isHover = true;}).mouseleave(()=>{isHover=false;}).click(e=>{
			let $this = $(e.target);
			$this.hasClass('division') && $this.parent('ul').siblings('.icon-menu').focus();
		});
		$menuWrap.append($(`<a href="#" class="icon-menu"></a>`).focusin(e=>{
			let $this = $(e.target);
			($this.offset().left < 150) && $this.siblings('ul').css('transform', 'translateX(80%)');
			$ddMenu.show();
		}).focusout(e=>{
			!isHover && $ddMenu.hide();
		})).click(e=>{e.preventDefault()});
		return $menuWrap.append($ddMenu);
	},
	convertDate: datetime=>{
		let newDate = new Date(datetime);
		function tenCheck(n){
			return n < 10 ?  '0'+n : n;
		}
		return `${newDate.getFullYear()}-${tenCheck(newDate.getMonth()+1)}-${tenCheck(newDate.getDate())} ${tenCheck(newDate.getHours())}:${tenCheck(newDate.getMinutes())}:${tenCheck(newDate.getSeconds())}`;
	},
	drag : $elmnt=>{
		let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0, posT = 0, posL = 0;
		if ($elmnt.find('[class$=header]').length) {
			$elmnt.find('[class$=header]').on('mousedown', dragMouseDown);
		} else {
			$elmnt.on('mousedown', dragMouseDown);
		}

		function dragMouseDown(e) {
			e = e || window.event;
			e.preventDefault();
			pos3 = e.clientX;
			pos4 = e.clientY;
			$(document).on('mouseup', closeDragElement).on('mousemove', elementDrag);
		}

		function elementDrag(e) {
			e = e || window.event;
			e.preventDefault();
			pos1 = pos3 - e.clientX;
			pos2 = pos4 - e.clientY;
			pos3 = e.clientX;
			pos4 = e.clientY;
			posT = $elmnt.offset().top - pos2,
			posL = $elmnt.offset().left - pos1;
			posT<60 ? posT = 60 : posT+$elmnt.height() > $(document).height() ? posT = $(document).height() - $elmnt.height() : '';
			posL<0 ? posL = 0 : posL+$elmnt.width() > $(document).width() ? posL = $(document).width() - $elmnt.width() : '';
			$elmnt.css('top', `${posT}px`);
			$elmnt.css('left', `${posL}px`);
		}

		function closeDragElement() {
			$(document).off('mouseup').off('mousemove');
		}
	},
	loader: {
		show : ()=>{
			let $loader = $('#loader');
			if(!$loader.length){
				$loader = $(`<div id="loader"><div class="loader"></div></div>`);
				$('body').append($loader);
			}
			$loader.show();
		},
		hide : ()=>{
			$('#loader').hide();
		}
	}
}
export default func;


// WEBPACK FOOTER //
// ./src/scripts/common/function.js